var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#1C74D0",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1586 20.2929C34.2018 21.4578 35.8735 21.4569 35.9164 20.2929V16.6692L34.1586 17.3117V20.2929Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6606 15.0086L25.6951 18.313C25.89 18.3843 26.1037 18.3843 26.2987 18.3132L35.3393 15.0088C36.1039 14.7301 36.1036 13.6362 35.3393 13.3578L26.3018 10.0535C26.1069 9.98217 25.8931 9.98217 25.6982 10.0535L16.6607 13.3578C15.8962 13.6363 15.8965 14.7302 16.6606 15.0086Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9438 29.1734C19.9438 27.5295 18.6064 26.1921 16.9625 26.1921C13.0129 26.342 13.014 32.0053 16.9626 32.1546C18.6064 32.1546 19.9438 30.8172 19.9438 29.1734Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0189 29.1734C38.0189 27.5295 36.6814 26.1921 35.0376 26.1921C31.088 26.342 31.0891 32.0053 35.0377 32.1546C36.6815 32.1546 38.0189 30.8172 38.0189 29.1734Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0188 29.1734C23.0188 30.8172 24.3562 32.1546 26 32.1546C29.9497 32.0048 29.9486 26.3414 26 26.1921C24.3562 26.1921 23.0188 27.5295 23.0188 29.1734Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0375 32.1548C33.8604 32.1548 32.762 32.4977 31.8367 33.0888C33.0063 34.4407 33.7143 36.1982 33.7143 38.1172V40.0001H40.1211C40.6065 40.0001 41 39.6066 41 39.1212V38.1172C41 34.8295 38.3253 32.1548 35.0375 32.1548Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.95 32.1548C22.6381 32.1548 19.9436 34.8295 19.9436 38.1173V40.0001H31.9566V38.1172C31.9565 34.8295 29.262 32.1548 25.95 32.1548Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9625 32.1548C13.6747 32.1548 11 34.8295 11 38.1172V39.1212C11 39.6066 11.3935 40.0001 11.8789 40.0001H18.1858V38.1172C18.1858 36.1791 18.908 34.4055 20.0986 33.0483C19.187 32.4823 18.1123 32.1548 16.9625 32.1548Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5859 21.3959V18.2522L26.9021 19.9641C26.3218 20.1777 25.6704 20.1777 25.0906 19.9636L20.4141 18.2532V21.3969C20.4141 21.7659 20.6446 22.0956 20.9911 22.2223L25.6951 23.9427C25.89 24.014 26.1038 24.014 26.2987 23.9428L31.0087 22.2215C31.3553 22.0948 31.5859 21.765 31.5859 21.3959Z",
    fill: "#1C74D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(11 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsImg);
export default __webpack_public_path__ + "static/media/studentsImg.22a0b489989c322e462fed219756d1d4.svg";
export { ForwardRef as ReactComponent };